import React from 'react'

export const CardUsersParticipate = ({ users = 0 }) => {
    return (
        <div className="flex justify-center items-center">
            <p className="text-black font-normal text-[40px]">{users}</p>
        </div>
    )
}

export default CardUsersParticipate